import React from 'react';

import useDateTimeCell from './date-time-cell.controller';

const ID = 'date-time-cell';
export interface DateTimeCellProps {
    className?: string;
    date?: Date | string | null;
    displayTime?: boolean;
    inline?: boolean;
}

export const DateTimeCell = (props: DateTimeCellProps) => {
    const viewProps = useDateTimeCell(props);

    return (
        <td
            id={ID}
            className={`text-foreground-default align-content-center px-4 py-2 text-sm font-medium ${props.className}`}>
            {props.date == null ? (
                '-'
            ) : (
                <>
                    {viewProps.date}
                    {props.displayTime && (
                        <>
                            {props.inline ? ' ' : <br />}
                            {viewProps.time}
                        </>
                    )}
                </>
            )}
        </td>
    );
};
